import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { IMAGES } from "@/data/content";

const NAV = [
  { label: "Team", to: "/#team" },
  { label: "Services", to: "/#services" },
  { label: "Packages", to: "/#packages" },
  { label: "Pricing", to: "/#pricing" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (to) => {
    setOpen(false);
    const hash = to.split("#")[1];
    if (hash) {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" }), 300);
      } else {
        document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(to);
    }
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#0D1B2A]/80 border-b border-[#F6F4F0]/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link" className="flex items-center group">
          <img src={IMAGES.logo} alt="4PS Marketing" className="h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-105 [filter:drop-shadow(0_2px_10px_rgba(0,0,0,0.75))]" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <button
              key={item.label}
              data-testid={`nav-${item.label.toLowerCase()}`}
              onClick={() => handleNav(item.to)}
              className="text-xs uppercase tracking-[0.2em] text-[#E5E7EB] hover:text-gold transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
          <button
            data-testid="nav-consultation-btn"
            onClick={() => navigate("/consultation")}
            className="text-xs uppercase tracking-[0.2em] px-6 py-3 bg-[#C8A96A] text-[#0D1B2A] hover:bg-[#F6F4F0] transition-colors duration-300 font-medium"
          >
            Book Consultation
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#F6F4F0]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden backdrop-blur-xl bg-[#0D1B2A]/95 border-t border-[#F6F4F0]/10 px-6 py-8 flex flex-col gap-6">
          {NAV.map((item) => (
            <button
              key={item.label}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              onClick={() => handleNav(item.to)}
              className="text-left text-sm uppercase tracking-[0.2em] text-[#E5E7EB]"
            >
              {item.label}
            </button>
          ))}
          <button
            data-testid="mobile-consultation-btn"
            onClick={() => { setOpen(false); navigate("/consultation"); }}
            className="text-sm uppercase tracking-[0.2em] px-6 py-4 bg-[#C8A96A] text-[#0D1B2A] font-medium"
          >
            Book Consultation
          </button>
        </div>
      )}
    </header>
  );
};
